export function errorHandler(error) {
  try {
    if (error.response && error.response.data && typeof error.response.data === 'string') {
      return error.response.data
    } else if (error.response && error.response.data && error.response.data.error) {
      return error.response.data.error
    } else if (importationErrorHandler.isImportationError(error)) {
      return importationErrorHandler.getErrorObj(error)
    } else if (error.message) {
      return error.message
    } else if (error.error) {
      return error.error
    } else if (typeof error === 'string') {
      return error
    } else {
      return JSON.stringify(error)
    }
  } catch (error) {
    throw new Error(`Erro: ${JSON.stringify(error)}`)
  }
}

export async function downloadErrorHandler(error) {
  const responseData = error && error.response && error.response.data

  if (responseData && typeof responseData.text === 'function') {
    const responseText = await responseData.text()

    if (responseText) {
      try {
        return errorHandler({ response: { data: JSON.parse(responseText) } })
      } catch (parseError) {
        return responseText
      }
    }
  }

  return errorHandler(error)
}
const importationErrorHandler = {
  isImportationError: error => {
    if (error.response) {
      if (error.response.data) {
        const {
          message,
          clientsNotSaved,
          productsNotSaved,
          productsWithInconsistency,
        } = error.response.data
        const hasAnyImportationList =
          clientsNotSaved !== undefined ||
          productsNotSaved !== undefined ||
          productsWithInconsistency !== undefined
        return Boolean(message && hasAnyImportationList)
      } else {
        return false
      }
    } else {
      return false
    }
  },
  getErrorObj: error => {
    const {
      message,
      clientsNotSaved = [],
      productsNotSaved = [],
      productsWithInconsistency = [],
    } = error.response.data
    return { message, clientsNotSaved, productsNotSaved, productsWithInconsistency }
  },
}
